<template>
  <div class="login">
    <!-- <div class="login__left"></div> -->
    <img class="login__left" src="../assets/images/login/home_left.png" alt="">
    <img class="login__right" src="../assets/images/login/home_right.png" alt="">
    <!-- <div class="login__right"></div> -->
    <div class="login__form">
      <div class="login__form__header">
         <img
          class="welcomecode"
          src="../assets/images/login/welcomecode.png"
        />
        <img
          class="welcome"
          src="../assets/images/login/welcome.png"
        />
      </div>
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="手机号登录" name="first">
            <div class="login__form__content">
              <form-input
                class="marginb-20"
                type="tel"
                @change="handleTelChange"
                @blur="handleBlur"
              />
              <div class="sendCode marginb-20">
                <form-input
                  type="code"
                  @change="handleCodeChange"
                />
                <send-code
                  :phone="loginInfo.phone"
                />
              </div>
              <div class="enCode marginb-20" v-show="pullImgCaptcha">
                <form-input
                  type="encode"
                  @change="handleEnCodeChange"
                />
                <span class="enCode__button" @click="handleGetEnCode">
                  <img :src="enImgurl" />
                </span>
              </div>
              <div
                class="login__form__login"
              >
                <span  v-show="tips.length >0" class="tips">{{ tips }}</span>
                <div
                  class="login__button"
                  @click="handleLoginClick"
                >
                  登录
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="账号密码登录" name="second">
            <div class="login__form__content">
              <form-input
                class="marginb-20"
                type="account"
                @change="handleAccountChange"
              />
              <form-input
                class="marginb-20"
                type="password"
                @change="handlePasswordChange"
              />
              <div
                class="login__form__login margintop-31"
              >
                <span  v-show="accountTips.length >0" class="tips">{{ accountTips }}</span>
                <div
                  class="login__button"
                  @click="handleAccountLoginClick"
                >
                  登录
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
      <div class="login__form__footer">
        <img
          class="login__peiyou"
          src="../assets/images/login/peiyoulogo.png"
        />
        <img
          class="login_logo"
          src="../assets/images/login/logo.png"
        />
      </div>
    </div>
    <div class="prompt" v-show="showPrompt">
      <div class="prompt__header">温馨提示</div>
      <p class="prompt__content">
        抱歉，没有找到您的手机号对应的账户信息，
        如果您确认该手机号已购买CodeMonkey限时闯关卡，
        且有效期至2020年6月30日之后，
        请添加小猴老师微信号houboshi1，
        与您核对账户信息后开通相应权限。
      </p>
      <span class="prompt__submit" @click="handlePromptClick">确定</span>
    </div>
    <Copyright class="copyright" />
  </div>
</template>

<script>
import Copyright from '@/components/Copyright.vue';
import formInput from '@/components/Input.vue';
import sendCode from '@/components/sendCode.vue';
import {
  login,
  getEnCode,
  showEnCode,
  userNameLogin,
} from '@/request/login';
import swal from '../utils/swal';
import { sBtoa } from '../utils/base64';
import { clearUserinfo } from '../request/userinfo';

export default {

  data() {
    return {
      loginInfo: {
        phone: '',
        code: '',
        enCode: '',
      },
      loginAccountInfo: {
        account: '',
        password: '',
      },
      enImgurl: '',
      pullImgCaptcha: false,
      validation: false,
      tips: '',
      accountTips: '',
      showPrompt: false,
      activeName: 'first',
    };
  },

  components: {
    formInput,
    sendCode,
    Copyright,
  },

  methods: {
    checkPhone(phone) {
      if (!phone) return false;
      if (!(/^1[3456789]\d{9}$/.test(phone))) {
        return false;
      }
      return true;
    },
    handleCodeChange(val) {
      this.loginInfo.code = val;
    },
    handleEnCodeChange(val) {
      this.loginInfo.enCode = val;
    },
    handleTelChange(val) {
      this.loginInfo.phone = val;
    },
    handleAccountChange(val) {
      this.loginAccountInfo.account = val;
    },
    handlePasswordChange(val) {
      this.loginAccountInfo.password = val;
    },
    async handleBlur(val) {
      try {
        const { status, data } = await showEnCode({ phone: val });
        if (status === 200) {
          this.pullImgCaptcha = data.data;
          if (data.data) {
            this.handleGetEnCode();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    validor() {
      const tips = {
        phone: '手机号格式错误，请重新输入！',
        code: '请输入短息验证码！',
        enCode: '请输入英文验证码！',
      };
      if (!this.checkPhone(this.loginInfo.phone)) {
        this.tips = tips.phone;
        return false;
      }
      if (!this.loginInfo.code) {
        this.tips = tips.code;
        return false;
      }
      if (!this.loginInfo.enCode && this.pullImgCaptcha) {
        this.tips = tips.enCode;
        return false;
      }
      this.tips = '';
      return true;
    },
    validorAccount() {
      const tips = {
        account: '请输入账号',
        password: '请输入密码',
      };
      if (!this.loginAccountInfo.account) {
        this.accountTips = tips.account;
        return false;
      }
      if (!this.loginAccountInfo.password) {
        this.accountTips = tips.password;
        return false;
      }
      this.accountTips = '';
      return true;
    },
    async handleGetEnCode() {
      try {
        const { status, data } = await getEnCode({
          phone: this.loginInfo.phone,
        });
        if (status === 200) {
          this.enImgurl = data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleLogin() {
      try {
        const params = {
          phone: this.loginInfo.phone,
          smsCaptcha: this.loginInfo.code,
          imgCaptcha: this.loginInfo.enCode,
        };
        const { status, data } = await login(params);
        if (status === 200) {
          this.tips = '';
          localStorage.setItem('CODEMONKEY_USERINFO', JSON.stringify({
            cmToken: data.data.token,
            cmTabs: 'JTVCMSUyQzIlMkMzJTJDNCUyQzUlMkM2JTVE',
          }));
          this.$router.push({
            path: '/cmlist',
            query: {
              tabs: 'JTVCMSUyQzIlMkMzJTJDNCUyQzUlMkM2JTVE',
            },
          });
        }
      } catch ({ status, data }) {
        if (status === 403 && data.data.pullImgCaptcha) {
          this.pullImgCaptcha = true;
          swal.error(`${data.message}`);
        } else if (status === 404) {
          this.showPrompt = true;
        } else {
          swal.error(`${data.message}`);
        }
        this.handleGetEnCode();
        this.tips = '';
      }
    },
    handleLoginClick() {
      this.validor();
      if (this.validor()) {
        this.handleLogin();
      }
    },
    async handleAccountLoginClick() {
      this.validorAccount();
      if (this.validorAccount()) {
        const {
          password,
          account: username,
        } = this.loginAccountInfo;
        try {
          const { status, data } = await userNameLogin({
            username,
            password,
          });
          if (status === 200) {
            const {
              cmCategoryList,
              token,
            } = data.data;
            const cmTabs = sBtoa(JSON.stringify(cmCategoryList));
            localStorage.setItem('CODEMONKEY_USERINFO', JSON.stringify({
              cmTabs,
              cmToken: token,
            }));
            this.$router.push({
              path: '/cmlist',
              query: {
                tabs: cmTabs,
              },
            });
          }
        } catch (error) {
          const { data } = error;
          const { status, message } = data;
          if (status === 400) {
            clearUserinfo();
            swal.error(`${message}`);
          }
        }
      }
    },
    handlePromptClick() {
      this.showPrompt = false;
    },
    handleClick(tab, event) {
      this.tips = '';
      this.accountTips = '';
      console.log(tab, event);
    },
  },
};

</script>
<style
lang='less'
scoped
src="@/assets/styles/login/login.less"
>
</style>
<style>
.el-tabs__item {
  font-size: 16px;
  color:rgba(102,102,102,1);
  line-height:22px;
}
.el-tabs__item:hover {
  color:rgba(102,102,102,1);
}
.el-tabs__item.is-active {
  color:rgba(51,51,51,1);
}
.el-tabs__active-bar {
  background:rgba(106,141,67,1);
  height: 3px;
  border-radius: 5px;
}
.el-tabs__nav-wrap::after {
  height: 3px;
  background-color: transparent;
}
.el-tabs__nav {
  float: none;
  left: 90px;
}
</style>
